import React, { useState } from 'react';
import { Form, Input, Select, Button, Row, Col, Space, message, Card } from 'antd';
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';

const { Option } = Select;

const testTypes = [
  { value: 'run', label: '🚀 Run Tests', description: 'Execute basic test suite' },
  { value: 'headed', label: '👁️ Run Headed', description: 'Run tests with browser visible' },
  { value: 'ui', label: '🎨 Run UI Mode', description: 'Interactive test UI' },
  { value: 'setup', label: '⚙️ Setup Only', description: 'Run authentication setup' },
  { value: 'clear-auth', label: '🔄 Clear Auth', description: 'Reset authentication state' }
];

function CreateExecution({ onCreateExecution }) {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);

    try {
      await onCreateExecution({
        plate: values.plate,
        req_number: values.req_number,
        phone_number: "1",
        req_date: values.req_date,
        test_type: values.test_type
      });

      message.success(`Execution created successfully for ${values.plate}!`);
    } catch (error) {
      message.error(`Failed to create execution for ${values.plate}`);
    } finally {
      setSubmitting(false);
    }
  };

  const validatePlate = (_, value) => {
    if (!value) {
      return Promise.reject(new Error('License plate is required'));
    }

    if (value.length < 2 || value.length > 10) {
      return Promise.reject(new Error('License plate must be between 2-10 characters'));
    }

    return Promise.resolve();
  };

  return (
    <Card title="Manual Entry" size="small">
      <Form
        layout="vertical"
        initialValues={{
          test_type: 'run',
          req_date: ''
        }}
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12} md={4}>
            <Form.Item
              label="License Plate"
              name="plate"
              rules={[
                { required: true, message: 'License plate is required' },
                { validator: validatePlate }
              ]}
            >
              <Input
                placeholder="e.g., ABC123"
                style={{ textTransform: 'uppercase' }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item
              label="Req Number"
              name="req_number"
              rules={[
                { required: true, message: 'Req number is required' },
              ]}
            >
              <Input
                placeholder="e.g., 354"
                type="text"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item
              label="Req Date"
              name="req_date"
              rules={[
                { required: true, message: 'Request date is required' }
              ]}
            >
              <Input type="text" placeholder='DD/MM/YYYY' />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item
              label="Test Type"
              name="test_type"
              rules={[
                { required: true, message: 'Test type is required' }
              ]}
            >
              <Select placeholder="Select test type">
                {testTypes.map(type => (
                  <Option key={type.value} value={type.value}>
                    <Space>
                      <span>{type.label}</span>
                    </Space>
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={4}>
            <Form.Item style={{ marginTop: '30px' }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={submitting}
                disabled={submitting}
                icon={submitting ? <LoadingOutlined /> : <PlusOutlined />}
                block
              >
                {submitting ? 'Creating...' : 'Create Execution'}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default CreateExecution;
